<div class="kind-collections-container static-collections-container">
  <div class="static-collections-header" [class.preview-header-mode]="previewMode" *ngIf="collection?.items?.length > 0">
    <div class="title" [style.opacity]="searchModel?.length > 0 || itemsAmount > 0 ? 1 : 0">
      Showing {{ itemsAmount }}
      {{ searchModel?.length > 0 ? (itemsAmount > 1 ? 'results' : 'result') : itemsAmount > 1 ? 'items' : 'item' }}
    </div>
    <div class="static-collections-header-buttons">
      <u-button
        class="delete-icon"
        elementSize="small"
        type="primary-danger"
        fontIcon="delete"
        [styles]="{ fontSize: '14px' }"
        (onClick)="onDelete()"
        [pTooltip]="collectionContent.deleteCollection"
        tooltipPosition="bottom"
        tooltipStyleClass="u-tooltip"
        *ngIf="checkedItems?.size > 0"
      ></u-button>
      <search-expandable-button
        *ngIf="collection?.items?.length > 0"
        (onChange)="formInputChanged.next($event)"
        (click)="showAddLinkInput = false; urlLink = null"
        size="large"
      ></search-expandable-button>
      <u-button
        (onClick)="changeLayout()"
        [versionNumber]="2"
        [typeElement]="'secondary'"
        [styleType]="'outlined'"
        [fontIcon]="layoutMode === 'list' ? 'gallery-view' : 'list-view'"
        [pTooltip]="layoutMode === 'list' ? 'Gallery layout' : 'List layout'"
        [iconStyles]="{ fontSize: '17px' }"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      >
      </u-button>
      <u-toggle-button
        *ngIf="previewHandlerService?.displayTogglePreview && collection?.items?.length > 0"
        (onChange)="previewHandlerService?.toggleResultsPreview(); isPreviewPressed = !isPreviewPressed"
        [checked]="previewHandlerService?.previewViewModel.previewState === 'side'"
        [onIcon]="'toggle-preview'"
        [outlined]="true"
        [pTooltip]="previewHandlerService?.getTogglePreviewTooltip()"
        tooltipPosition="left"
        tooltipStyleClass="u-tooltip"
      >
      </u-toggle-button>
      <u-button
        #plusButton
        *ngIf="collection?.items?.length > 0 && canEdit"
        class="add-icon"
        elementSize="small"
        type="primary"
        fontIcon="plus"
        [label]="collectionContent.addItem"
        [styles]="{ fontSize: '14px' }"
        (click)="onLinkTelemetry('btn_click'); addNewItem($event, 'button')"
      ></u-button>
    </div>
  </div>

  <div class="add-link" *ngIf="showAddLinkInput">
    <u-input
      class="add-link-input"
      (onChange)="onChangeAddLink($event)"
      [placeholder]="collectionContent.addLinkInputPlaceholder"
      inputSize="small"
      [model]="urlLink"
      [isSearchInput]="true"
      [inputFocus]="true"
      [errorBorder]="showErrorInputAddLink"
      [errorText]="collectionContent.addLinkInputError"
      (onEnter)="onAddLink()"
      (keydown.enter)="$event.stopPropagation(); onAddLink()"
      [disabled]="loadingUrlLink"
      (onClear)="onLinkTelemetry('clear')"
      (outsideClick)="onAddLink()"
      [ignoreElement]="plusButton?.button"
    ></u-input>
  </div>
  <drag-and-drop [disabled]="disabledDND()" [disabledPaste]="disabledPaste()" (fileAdded)="onDropItems($event)">
    <ng-container *ngIf="!collection?.items?.length && !loadingItem?.amount; else results">
      <div class="empty-state-wrapper" *ngIf="canEdit; else viewer">
        <div class="static-collection-empty-state">
          <u-icon class="file-add" [model]="{ type: 'font', value: 'icon-file-add' }" [styles]="{ fontSize: '28px' }"></u-icon>
          <div class="empty-state-text-container">
            <span class="empty-state-text">{{ collectionContent.staticCollectionEmptyState }}</span> <br />
          </div>
          <div class="add-link-button">
            <u-button
              #emptyStateButton
              class="delete-icon"
              data-cy="add-item-button"
              elementSize="medium"
              [label]="collectionContent.addItem"
              type="primary"
              fontIcon="plus"
              [styles]="{ fontSize: '12px', width: '114px' }"
              (click)="onLinkTelemetry('btn_click'); addNewItem($event, 'empty-state')"
            ></u-button>
          </div>
        </div>
      </div>
      <ng-template #viewer>
        <div class="viewer-empty-state-wrapper">
          <u-icon class="sad-doc" [model]="{ type: 'font', value: 'icon-sad-doc' }" [styles]="{ fontSize: '28px' }"></u-icon>
          <p class="text">Nothing to see yet</p>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #results>
      <div class="search-results-container">
        <search-results-list
          [ngClass]="{ 'static-search-results-list': layoutMode === 'list' }"
          [displayedContext]="displayedContext$ | async"
          [items]="items$ | async"
          [isOwner]="canEdit"
          (nextPage)="nextPage($event)"
          [componentFocused]="componentFocused === CollectionsComponentFocused.RESULTS"
          (componentFocusedFinish)="componentFocusedFinish.emit($event)"
          [listView]="
            canEdit ? { isEditable: true, isDraggable: searchModel === '' || !searchModel } : { isEditable: false, isDraggable: false }
          "
          (checkedItemsUpdate)="checkedItemsUpdate($event)"
          (selectedIndexChanged)="onSelectedIndexChanged($event)"
          [clearCheckedItems]="clearCheckedItems"
          (titleChanged)="titleChanged($event)"
          (onRenameFlow)="onRenameFlow($event)"
          (onDynamicCommand)="onDynamicCommand($event)"
          (onDragChange)="onDragChange($event)"
          [emptyResults]="emptyResults$ | async"
          [loadingItem]="loadingItem"
          [listName]="'static_collections'"
          [changedData]="collectionChanged"
          [displayBg]="dragAndDrop !== 'drag_over'"
          pageType="static-collection"
          (changePreviewMode)="previewMode = $event.isPreviewMode; showPreviewButton = $event.showBtn"
          [layoutMode]="layoutMode"
          [resizeChange]="isPreviewPressed"
          [virtualScroll]="false"
          [actionsReadOnly]="true"
          [inlineButtons]="true"
          [updateHeight]="updateHeight"
        ></search-results-list>
      </div>
    </ng-template>
  </drag-and-drop>
</div>
